// extracted by mini-css-extract-plugin
export default {"container":"SidePanelContainer_container__Sc0SA"};